import React, { useState, useEffect } from 'react';
import './PrivadaArtemisa.scss'
import RecorridoArtemisa from '../RecorridoArtemisa/RecorridoArtemisa';
import AmenidadesArtemisa from '../AmenidadesArtemisa/AmenidadesArtemisa'
import AmenidadesDescArtemisa from '../AmenidadesDescArtemisa/AmenidadesDesc';
import { useTranslation } from 'react-i18next';

const PrivadaArtemisa = () => {
  const { t } = useTranslation();
  const [showStiky, setShowStiky] = useState('ocultar');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div id="amenmapa" className='contenedor_home_artemisa_desc'>
        <img className='contenedor_home_artemisa_fondo' src="/assets/Artemisa/img-cover-privada-artemisa.jpg" alt="" />
        <div className='contenedor_home_artemisa__slider_card_logo'>
          <div className="contenedor-home-principal-artemisa">
            <img src="/assets/Artemisa/img-logo-artemisa.svg" alt="Logo Artemisa" />
            <div className='button_dispo_artemisa'>
              <a href='https://disponibilidad.velasur.mx/privada-artemisa'>
                {t('buttons.seeAvailability')}
              </a>
            </div>
          </div>   
        </div>
        <a
          id="ws_script"
          href="https://api.whatsapp.com/send?phone=524461340798&text"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://multipagos.velasresorts.com/images/WhatsApp_Logo_1.png"
            width="65"
            height="65"
            alt="WhatsApp"
          />
        </a>
      </div>
      <RecorridoArtemisa/>
      <AmenidadesArtemisa/>
      <AmenidadesDescArtemisa/>
    </>
  );
}
export default PrivadaArtemisa;
